(function () {
  'use strict';
  console.log('Poppys cart fixes loaded');

  function isCartDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');

    var bodyOpen =
      document.body.classList.contains('js-drawer-open-cart') ||
      document.body.classList.contains('js-drawer-open');

    if (!drawer) return bodyOpen;

    var drawerOpen =
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('open') ||
      drawer.getAttribute('aria-hidden') === 'false';

    return bodyOpen || drawerOpen;
  }

  function isInsideCartDrawer(element) {
    return element.closest && element.closest('#CartDrawer');
  }

  function findStickyAddToCartElements() {
    var matches = [];
    var elements = document.querySelectorAll('button, a, div');

    elements.forEach(function (element) {
      if (isInsideCartDrawer(element)) return;

      var text = (element.textContent || '').trim().toLowerCase();

      var isAddToCartText =
        text === 'agregar al carrito' ||
        text === 'add to cart';

      if (!isAddToCartText) return;

      var current = element;

      for (var i = 0; i < 6 && current; i++) {
        var style = window.getComputedStyle(current);

        if (
          style.position === 'fixed' ||
          style.position === 'sticky'
        ) {
          matches.push(current);
          return;
        }

        current = current.parentElement;
      }
    });

    return matches;
  }

  function hideSticky() {
    findStickyAddToCartElements().forEach(function (element) {
      element.setAttribute('data-poppys-hidden-xb', 'true');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function showSticky() {
    document.querySelectorAll('[data-poppys-hidden-xb="true"]').forEach(function (element) {
      element.removeAttribute('data-poppys-hidden-xb');
      element.style.removeProperty('visibility');
      element.style.removeProperty('pointer-events');
    });
  }

  function syncSticky() {
    if (isCartDrawerOpen()) {
      hideSticky();
    } else {
      showSticky();
    }
  }

  function start() {
    var drawer = document.getElementById('CartDrawer');

    new MutationObserver(syncSticky).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style']
    });

    if (drawer) {
      new MutationObserver(syncSticky).observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'style']
      });
    }

    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    document.addEventListener('click', function () {
      setTimeout(syncSticky, 100);
      setTimeout(syncSticky, 500);
    });

    setInterval(syncSticky, 300);
    syncSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();